import { render } from "./ModalChooseCashRegister.vue?vue&type=template&id=2da1d7b6"
import script from "./ModalChooseCashRegister.vue?vue&type=script&lang=js"
export * from "./ModalChooseCashRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__